export enum PaymentType {
    Unknown = -1,
    Offline = 0,
    NetaxeptNG = 2,
    Invoice = 3,
    NetaxeptDirect = 4,
    ProtxDirect = 5,
    BBSNts = 6,
    BBSNtsRedirect = 7,
    ProtxRedirect = 8,
    ParticipantInvoice = 9,
    Realex = 10,
    Vipps = 11,
    Efaktura = 12,
    Opayo = 14,
    Stripe = 15,
    StripeInvoice = 16,
    Adyen = 17
}
